export const ACCOUNT_RECEIVABLE = "/reports/account-receivable";
